import React, { useMemo, useState } from "react";
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion";
import { GALLERY_PHOTOS } from "../photoManifest";
import { WALL_HEADER, WALL_SUB } from "../MothersDayData";

const WallAct = ({ onNext }) => {
  const [open, setOpen] = useState(null); // index

  const tiles = useMemo(
    () =>
      GALLERY_PHOTOS.map((src, i) => ({
        src,
        rotate: ((i * 37) % 11) - 5, // -5..+5 deg
        delay: (i % 12) * 0.04,
      })),
    []
  );

  return (
    <motion.div
      className="md-act md-act-wall"
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -16 }}
      transition={{ duration: 0.6 }}
    >
      <div className="md-act-header">
        <h1>{WALL_HEADER}</h1>
        <div className="md-sub">{WALL_SUB}</div>
      </div>

      <div className="md-wall-grid">
        {tiles.map((t, i) => (
          <motion.button
            key={t.src}
            className="md-polaroid"
            initial={{ opacity: 0, y: 20, rotate: t.rotate - 6 }}
            animate={{ opacity: 1, y: 0, rotate: t.rotate }}
            transition={{ delay: t.delay, duration: 0.55, ease: "easeOut" }}
            whileHover={{ scale: 1.04, rotate: 0, zIndex: 5 }}
            onClick={() => setOpen(i)}
            aria-label="open photo"
          >
            <span className="md-polaroid-img" style={{ backgroundImage: `url(${t.src})` }} />
            <span className="md-polaroid-tape" />
          </motion.button>
        ))}
      </div>

      <div className="md-wall-footer">
        <button className="md-btn-soft md-cta" onClick={onNext}>
          One more thing — a letter →
        </button>
      </div>

      <AnimatePresence>
        {open !== null && (
          <motion.div
            className="md-lightbox"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setOpen(null)}
          >
            <motion.img
              key={open}
              src={tiles[open].src}
              alt="memory"
              className="md-lightbox-img"
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              transition={{ duration: 0.3 }}
            />
            <div className="md-lightbox-controls" onClick={(e) => e.stopPropagation()}>
              <button className="md-btn-link" onClick={() => setOpen((o) => Math.max(0, o - 1))} disabled={open === 0}>← prev</button>
              <button className="md-btn-link" onClick={() => setOpen(null)}>close ✕</button>
              <button className="md-btn-link" onClick={() => setOpen((o) => Math.min(tiles.length - 1, o + 1))} disabled={open === tiles.length - 1}>next →</button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
};

export default WallAct;
